import { render, staticRenderFns } from "./GuanYuWoMenView.vue?vue&type=template&id=2cdbfcb1&scoped=true"
import script from "./GuanYuWoMenView.vue?vue&type=script&lang=js"
export * from "./GuanYuWoMenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdbfcb1",
  null
  
)

export default component.exports